module.exports = __webpack_public_path__ + "static/media/11.8f38c9d0.jpg";